var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.final_audit_status !== 3)?_c('div',{staticClass:"audit_temp",class:_vm.resultObj[_vm.final_audit_status].label},[_c('p',[_vm._v("审核状态："+_vm._s(_vm.resultObj[_vm.final_audit_status].name))]),(_vm.final_audit_status === 1)?_c('p',[_vm._v(_vm._s(_vm.final_audit_remark))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }